// src/Views/WhoIAm.js — Flasher AboutSection.
import React from 'react';
import { Eyebrow, ScrambleText } from '../components/primitives';
import { ABOUT_TAGS } from './siteData';

const WhoIAm = () => {
  return (
    <section id="about" style={{ position: 'relative', padding: '120px 28px', zIndex: 2 }}>
      <div
        className="about-grid"
        style={{
          maxWidth: 1080,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.6fr)',
          gap: 64,
          alignItems: 'start',
        }}
      >
        <div>
          <Eyebrow accent="var(--purple)">⏵ ABOUT — solomon.foshko</Eyebrow>
          <h2
            style={{
              fontFamily: 'var(--f-display)',
              fontSize: 'clamp(40px, 5.5vw, 80px)',
              fontWeight: 600,
              lineHeight: 1.08,
              letterSpacing: '-0.03em',
              margin: 0,
              color: 'var(--ink)',
              paddingBottom: '0.1em',
            }}
          >
            <ScrambleText duration={1100}>Builder.</ScrambleText>
            <br />
            <span
              style={{
                fontStyle: 'italic',
                fontWeight: 400,
                background: 'linear-gradient(120deg, var(--purple), var(--magenta))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                paddingRight: '0.18em',
                paddingBottom: '0.05em',
                display: 'inline-block',
              }}
            >
              Coach.
            </span>
            <br />
            <span
              style={{
                fontStyle: 'italic',
                fontWeight: 400,
                background: 'linear-gradient(120deg, var(--magenta), var(--cyan))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                paddingRight: '0.18em',
                paddingBottom: '0.05em',
                display: 'inline-block',
              }}
            >
              Operator.
            </span>
          </h2>

          <div style={{ marginTop: 28, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {ABOUT_TAGS.map((tag) => (
              <span
                key={tag}
                style={{
                  fontFamily: 'var(--f-mono)',
                  fontSize: 10,
                  letterSpacing: '0.18em',
                  color: 'var(--ink-2)',
                  padding: '6px 12px',
                  borderRadius: 999,
                  border: '1px solid var(--line)',
                  background: 'rgba(160,102,255,0.06)',
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
          <p style={{ fontSize: 17, lineHeight: 1.65, color: 'var(--ink-2)', margin: 0 }}>
            I'm Solomon Foshko. I live in Austin. I coach nationally ranked middle and
            elementary school archery teams under our club, Bat City Archery, and that
            experience shapes how I think about building: you teach fundamentals, you create
            conditions for practice, and you let people surprise you with what they can do.
          </p>
          <p style={{ fontSize: 17, lineHeight: 1.65, color: 'var(--ink-2)', margin: 0 }}>
            I play an unreasonable amount of Dominion. I follow the games industry not just
            as a player but as an intelligence discipline: tracking signals, mapping
            competitive landscapes, identifying structural shifts before they become obvious.
          </p>
          <p style={{ fontSize: 17, lineHeight: 1.65, color: 'var(--ink-2)', margin: 0 }}>
            Years in competitive intelligence and user research trained me to see problems as
            systems and information as something to be actively gathered, assessed, and acted
            on. In 2024, I started building{' '}
            <em style={{ color: 'var(--ink)', fontStyle: 'normal' }}>with</em> AI agents — not
            using AI, building with it.
          </p>
          <p
            style={{
              fontSize: 18,
              lineHeight: 1.6,
              color: 'var(--ink)',
              margin: 0,
              paddingTop: 22,
              borderTop: '1px solid var(--line)',
              fontWeight: 500,
            }}
          >
            The bottleneck has moved. It's no longer about which tool to use → it's about
            upgrading how you think.{' '}
            <span
              style={{
                background: 'linear-gradient(120deg, var(--magenta), var(--cyan))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontStyle: 'italic',
                paddingRight: '0.12em',
              }}
            >
              That's what I do. That's what I can help you do.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoIAm;
